export const SAMS_CLUB_PROMO_CODE = 'samsclub'

export const ANNUAL_PASS = 'annual-pass'
export const FAMILY = 'Family'
export const INDIVIDUAL = 'Individual'
export const DUO = 'Duo'
